"use strict";

Shopify.theme.jsSlideshowCustom  = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsSlideshowCustom = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors

    var $slideshow = $section.find('[data-slideshow-custom]').removeClass('is-hidden');
    var $slider = $slideshow.flickity({
      wrapAround: true,
      prevNextButtons: true,
      rightToLeft :true,
      pageDots: true,
      draggable: true,
      imagesLoaded: true,
      cellAlign:'left',
      arrowShape:'M10.2689 21.6823L11.7311 20.3176L3.03455 10.9999L11.7311 1.68225L10.2689 0.317616L0.298782 10.9999L10.2689 21.6823Z'
    });
    
    $slider.on('dragMove.flickity', function( event, pointer ) {
      let $cursor = $('.cursor');
      if(!$cursor.length){
      	$slider.off('dragMove.flickity')
        return
      }
      $cursor.css({
          top: event.clientY - $cursor.height() / 2,
          left: event.clientX - $cursor.width() / 2
      });
    });
    
    setTimeout(function () {
      $slider.flickity('resize');
    }, 500);
  },
  blockSelect: function blockSelect($section, blockId) {
    var $slider = $section.find('[data-image-slideshow]');
    var $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');
    $slider.flickity('select', $sliderIndex, true, true);
  },
  unload: function unload($section) {}
};